module.exports = {"US":{"callsemaillabel":"Calls\\Email","customertask":"Customer Tasks","task":"Task"},"CA":{"callsemaillabel":"Collection Activity","customertask":"Account Activity","task":"Account Activity"}}


//////////////////
// WEBPACK FOOTER
// ./src/labelname.json
// module id = GPje
// module chunks = 1